function spu_createCookie(name, value, hours)
{
    if (hours)
    {
        var date = new Date();
        date.setTime(date.getTime()+(hours*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else
    {
        var expires = "";
    }

    document.cookie = name+"="+value+expires+"; path=/";
}

function getCookie(name) {
    var match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)')); return match ? match[1] : null;
}

if(document.querySelector('.popup_inicio')){
    const popup = document.querySelector('.popup_inicio');
    const popupactivo = document.querySelector('.popup_inicio input.popactivo');
    const mainpopup = popup.parentElement.parentElement
    const cerrar = popup.querySelector('.cerrar')
    const COOKIENAME = 'popupmovup'
    if(!getCookie(COOKIENAME)){
        if(popupactivo.value === "1"){


            setTimeout(() => {
                mainpopup.classList.add('active')
            }, 2500);

            spu_createCookie(COOKIENAME,'true', 24)
        }
    }
    
    cerrar.addEventListener('click', ()=>{
        mainpopup.classList.remove('active')
        document.querySelector('body').style.overflow = 'visible'
    })
}